
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.825.046A2.84 2.84 0 00-.003 2.875v12.343a2.84 2.84 0 002.828 2.828h12.343a2.84 2.84 0 002.829-2.828V2.875A2.84 2.84 0 0015.168.046zm0 1.543h12.343c.726 0 1.286.56 1.286 1.286v3.343c-4.972-.006-9.943.01-14.914-.006V2.875c0-.726.56-1.286 1.285-1.286zM1.54 7.764c4.97-.008 9.942-.004 14.914-.004v7.458c0 .725-.56 1.285-1.286 1.285H2.825c-.725 0-1.285-.56-1.285-1.285z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    